// =============================================
// workspace.ts — sync getter dla aktywnego workspace
// =============================================
// Czytany przez fetch wrappery (poza React lifecycle) — apiBase.ts +
// dataForSeoService + worker (fallback). Spojny z useWorkspace.tsx
// (ten sam localStorage key, ta sama lista wartosci).
//
// Phase 3 C2 of feat/workspace-api-keys (2026-05-26).
// =============================================

export type Workspace = "firma" | "sideprojects";

const LS_KEY = "app_workspace";
const DEFAULT_WS: Workspace = "firma";

/**
 * Synchronicznie pobierz aktualny workspace z localStorage.
 *
 * - Browser: czyta `localStorage.app_workspace` (ten sam klucz co useWorkspace.tsx)
 * - SSR/Node (worker): zwraca "firma" jako fallback. Worker server-side dostanie
 *   workspace przez job payload (Phase 3.5 backlog) — wtedy ustawi process.env
 *   przed wewnetrznym fetch lub pasuje jako parametr.
 * - Cross-tab sync: jest automatyczny bo czytamy localStorage on-demand
 *   (useWorkspace.tsx invaliduje React state przez StorageEvent — fetch wrapper
 *   nie potrzebuje tego mechanizmu, czyta swiezo przy kazdym callu).
 *
 * Bezpieczny dla unknown values: jesli localStorage zawiera cos innego niz
 * "firma" / "sideprojects" (np. legacy/corrupted) — zwroci default "firma".
 */
export function getActiveWorkspace(): Workspace {
  if (typeof window === "undefined") return DEFAULT_WS;
  try {
    const stored = window.localStorage?.getItem(LS_KEY);
    return stored === "sideprojects" ? "sideprojects" : DEFAULT_WS;
  } catch {
    // localStorage może rzucić w privacy mode / disabled storage
    return DEFAULT_WS;
  }
}
